<app-card-table
    [tableTitle]="'workData.groupActivity.workersTitle'"
    [columns]="columns"
    [items]="_users()"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    [showPagination]="false"
>
    <ng-template pTemplate="user" let-item="item">
        <app-user-chip
            [user]="item"
            [renderType]="UserChipRenderTypeEnum.User"
            [renderDetails]="false"
        ></app-user-chip>
    </ng-template>

    <ng-template pTemplate="applications" let-item="item">
        <app-number-input
            #applications
            [attributes]="{ userId: item.id }"
            id="applications"
            [showLabel]="false"
            [showButtons]="true"
            [max]="maximumDuration()"
            [min]="minimumDurations()?.[item.id] || 0"
            [disabled]="disabled()"
        ></app-number-input>
    </ng-template>

    <ng-template pTemplate="durationNote" let-item="item">
        <app-number-input
            #durationNote
            [attributes]="{ userId: item.id }"
            id="durationNote"
            [showLabel]="false"
            [showButtons]="true"
            [min]="0"
            [disabled]="disabled()"
        ></app-number-input>
    </ng-template>

    <ng-template pTemplate="durationPreparation" let-item="item">
        <app-number-input
            #durationPreparation
            [attributes]="{ userId: item.id }"
            id="durationPreparation"
            [showLabel]="false"
            [showButtons]="true"
            [min]="0"
            [disabled]="disabled()"
        ></app-number-input>
    </ng-template>

    <ng-template pTemplate="durationSelfReflection" let-item="item">
        <app-number-input
            #durationSelfReflection
            [attributes]="{ userId: item.id }"
            id="durationSelfReflection"
            [showLabel]="false"
            [showButtons]="true"
            [min]="0"
            [disabled]="disabled()"
        ></app-number-input>
    </ng-template>
</app-card-table>
